import React from 'react'

const About = () => {
    return (
      <div className="container grid bg-gray-300 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-5 mx-auto mt-10 card shadow-xl p-10">
        <h1 className="text-3xl font-bold">About Us</h1>
        <h2 className="text-3xl font-bold">National Tools Industries</h2>
        <div>
          <img
            src="https://www.manufacturingtodayindia.com/cloud/2022/03/15/kHbwzTeY-Cutting-tools-1200x675.jpg"
            alt=""
          />
        </div>
        <div>
          <p>
            Established in the year 2004, National Tools Industries has
            successfully created a market by providing excellent quality
            products. We are based out s a Sole Proprietorship firm and we have
            situated our operational head at Kolkata, West Bengal (India). We
            are betrothed in manufacturing and supplying wide range of Multi
            Cavity Molding Die, Zinc Die Casting Mold, Aluminium Die Casting
            Mold, Pressure Die Casting Mold and many more. Additionally, Our
            well-installed infrastructural facilities help us to deliver these
            products as per the market requirements and customer’s demands. Our
            brilliant and enthusiastic professionals fulfil the needs and
            necessities of the customers in an effectual way. Apart from, we
            also deliver these products at market leading prices. Our experts
            carry rich experience and wide knowledge about the domain.
          </p>

          <p>
            Under the esteemed supervision of Mr. Dipak Dasgupta (Proprietor),
            our company National Tools Industries has created a renowned
            position in the market. With his immense management skills, he
            manages and directs the activities of the organization in a fruitful
            manner.
          </p>

          <p>
            We have a team of skillful experts which is the backbone of the
            association. These professionals have vast industry experience and
            deep information in this domain. Our professionals work with
            enthusiasm to deliver the best products to our customers. To boost
            knowledge of our professionals, our organization conducts the
            several training and workshops at regular intervals.
          </p>
        </div>
        <div>
          <p className="text-3xl font-bold">Vision</p>
          <p className="my-3">
            A united, integrated, enlightened, passionate, empowered and
            liberated community of motorcyclists – basically a Republic of
            Bikers
          </p>
          <p className="text-3xl font-bold">Mission</p>
          <p>
            To develop a community of passionate motorcycle users with a view to
          </p>
          <ol className="my-4">
            <li className="my-2">
              - integrate and unite them based on their mutual needs and
              interests
            </li>
            <li className="my-2">
              - enlighten them to reach the global standard of scopes of
              motorcycling
            </li>
            <li className="my-2">
              - empower them with upgrades and tailored solutions to realize
              their desire
            </li>
            <li className="my-2">
              - professionalize their hobbies for a sustainable balance of work
              and pleasure
            </li>
            <li className="my-2">
              - liberate them for exploring the beautiful creation of Allah
              Subhanahu wa Ta’ala on their favorite ride.
            </li>
          </ol>
        </div>
        <div>
          <img
            src="https://cdn.elearningindustry.com/wp-content/uploads/2021/05/shutterstock_772107742.png"
            alt=""
          />
        </div>
      </div>
    );
}

export default About